import {
  EndPoints,
  HttpMethods,
  PrescriberProfile,
  TherapistProfile,
} from 'interfaces';
import {Response} from 'redaxios';
import {unwrapAPIError} from 'utils';

import {CometChat} from '@cometchat-pro/chat';

import {requestHandler} from '../HTTP';

const getLoggedInUser = async (): Promise<CometChat.User | null> => {
  const res = await CometChat.getLoggedinUser();
  return res;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logout = async (): Promise<any | null> => {
  if (await CometChat.getLoggedinUser()) {
    return CometChat.logout();
  }
  return null;
};

const reactivateAccount = async (): Promise<
  Response<{message: TherapistProfile | PrescriberProfile}>
> => {
  try {
    const res = await requestHandler<{
      message: TherapistProfile | PrescriberProfile;
    }>({
      method: HttpMethods.PUT,
      url: EndPoints.ReactivateCometUser,
    });
    return res;
  } catch (error) {
    const errorValue = unwrapAPIError(error);
    return Promise.reject(errorValue);
  }
};

const deactivateAccount = async (): Promise<
  Response<{message: TherapistProfile | PrescriberProfile}>
> => {
  try {
    const res = await requestHandler<{
      message: TherapistProfile | PrescriberProfile;
    }>({
      method: HttpMethods.DELETE,
      url: EndPoints.DeactivateCometUser,
    });
    return res;
  } catch (error) {
    const errorValue = unwrapAPIError(error);
    return Promise.reject(errorValue);
  }
};

/**
 * CometChatService
 */
export const CometChatService = {
  getLoggedInUser,
  logout,
  reactivateAccount,
  deactivateAccount,
};
